import type { Release } from '../releases.ts';

export default {
  version: '0.95.0',
  date: '2026-10-09',
  title: 'Fixes and operations: burned-in subtitles, Queued, Export locations',
  summary: [
    'Jobs waiting for a free worker show as Queued, with how long they have waited',
    'Progress for copies between locations, burned-in subtitles and graphics renders',
    'Export locations have their own tab in Administration',
    'Graphics can be deleted to the recycle bin',
    'Fixed: exports with many burned-in subtitles no longer run out of memory',
    'Fixed: Recent failures lists only the last 24 hours',
  ],
  features: [
    'Jobs that wait for a free worker show as “Queued · waiting for a free worker”, with how long they have waited, instead of running at 0%: in Monitor (ingests, exports and copies), the export lists, the asset’s Storage tab, System status → Jobs and Operations. Once a worker has the job, a slim progress bar shows the step and the percent',
    'Progress for copies between storage locations (from the bytes copied), for rendering burned-in subtitles and for rendering graphics',
    'Administration → Export locations: export destinations have their own tab, after Watch folders. The exports tier is still chosen on Storage',
    'Graphics area: Delete moves a graphic to the recycle bin (with the Delete permission). It asks first and says how many sequences use the graphic; their clips keep rendering the version they use',
    'Docker Compose: the transcode worker may use 3 GB of memory (was 2 GB). If you set your own limit in an override, check it',
  ],
  fixes: [
    'Exports with burned-in subtitles: an export with many subtitles no longer fails with “ffmpeg was terminated (SIGKILL)”. The subtitles are now one input to the render instead of one per subtitle, so the memory the render needs no longer grows with the number of subtitles. Their timing is unchanged',
    'When the system stops a render for lack of memory, the export says so (“killed by the system, probably out of memory; raise the transcode worker’s memory limit”) instead of only “terminated (SIGKILL)”',
    'Operations → Recent failures lists the failures of the last 24 hours only, like the other cards there',
  ],
} satisfies Release;
